// 导入请求数据的 request 模块
import request from '@/utils/request'

// 查询商品信息
export const selectTrainAPI = (currentPage, pageSize) => {
  return request.get('/train/select', {
    params: {
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据商品名称查询商品信息
export const getTrainNameAPI = (name, currentPage, pageSize) => {
  return request.get('/train/select/name', {
    params: {
      name: name,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据时间查询商品信息
export const selectTrainTimeAPI = (currentPage, pageSize) => {
  return request.get('/train/select/time', {
    params: {
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据推荐查询商品信息
export const selectTrainSuggestAPI = (currentPage, pageSize) => {
  return request.get('/train/select/suggest', {
    params: {
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}
